var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3931_7450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3296 26.7523C20.3296 28.0288 19.2813 29.0731 18.0001 29.0731C16.7188 29.0731 15.6705 28.0288 15.6705 26.7523M24.9887 14.4453V18.6031C24.9887 19.6556 25.4078 20.6648 26.1535 21.4076L27.077 22.3276C27.2314 22.4815 27.3182 22.6905 27.3182 22.9085V22.9085C27.3182 23.3613 26.9512 23.7283 26.4984 23.7283H9.50175C9.04895 23.7283 8.68188 23.3613 8.68188 22.9085V22.9085C8.68188 22.6905 8.76869 22.4815 8.92312 22.3276L9.84666 21.4076C10.5923 20.6648 11.0114 19.6556 11.0114 18.6031V14.4453C11.0114 10.8893 12.9025 7.93071 16.2027 7.12382C16.2359 7.11571 16.2691 7.10833 16.3026 7.1018C16.5 7.06338 17.2531 6.92675 17.981 6.92674C18.6941 6.92672 19.4583 7.05786 19.6822 7.09933C19.7257 7.10739 19.7692 7.11683 19.8121 7.12739C23.1147 7.93953 24.9887 10.9061 24.9887 14.4453Z",
    stroke: "#495057",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3931_7450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.653b5d56.svg";
export { ForwardRef as ReactComponent };